/** «Рассылки» → «Напоминание о примерке» — ровно то, что отдаёт `GET /api/mailing/remind`. */
import { apiFetch, query } from "@/lib/api";

/** Отправлено, подтвердили и отменили запись кнопкой, пришли в салон в день записи — по дню своей рассылки. */
export type RemindCounts = { sent: number; confirmed: number; cancelled: number; came: number };

export type RemindDay = {
  day: string;
  /** Только каналы, куда в этот день что-то ушло. */
  channels: Record<string, RemindCounts>;
  total: RemindCounts;
};

export type MailingRemind = {
  from: string;
  to: string;
  /** Бесплатные каналы в порядке выбора; WhatsApp в этой рассылке нет. */
  channels: string[];
  /** Дни с отправками, свежие сверху. */
  days: RemindDay[];
  total: { channels: Record<string, RemindCounts>; all: RemindCounts };
};

export function loadMailingRemind(from: string, to: string): Promise<MailingRemind> {
  return apiFetch<MailingRemind>(`/api/mailing/remind${query({ from, to })}`);
}
